// avstemming-general-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'ava.common.notCompared': 'Not compared',
  'ava.common.enterAmount': 'Enter an amount.',
  'ava.common.date': 'Date',
  'ava.common.amount': 'Amount',
  'ava.common.remove': 'Remove',
  'ava.common.add': 'Add',
  'ava.common.account': 'Account',
  'ava.common.status': 'Status',
  'ava.common.requestDocs': 'Request documentation',
  'ava.common.close': 'Close',
  'ava.common.cancel': 'Cancel',
  'ava.common.source': 'Source',
  'ava.common.type': 'Type',
  'ava.common.voucher': 'Voucher',
  'ava.common.description': 'Description',
  'ava.common.fileNotFound': 'The file was not found in storage.',
  'ava.status.notChecked': 'Not checked',
  'ava.status.ok': 'OK',
  'ava.status.deviation': 'Deviation',
  'ava.status.notRelevant': 'Not relevant',
  'ava.item.class.timing': 'Timing difference',
  'ava.item.class.missingVoucher': 'Missing voucher',
  'ava.item.class.misposting': 'Posting error',
  'ava.item.class.unidentified': 'Unidentified',
  'ava.item.class.other': 'Other',
  'ava.item.action.none': 'None',
  'ava.item.action.followUp': 'Follow up next period',
  'ava.item.action.createAdjustment': 'Create adjustment voucher',
  'ava.item.action.requestDocs': 'Ask the client for documentation',
  'ava.account.bookedBalance': 'Booked balance',
  'ava.diff.externalBalance': 'External balance',
  'ava.diff.notEntered': 'Not entered',
  'ava.diff.preliminary': 'Preliminary difference',
  'ava.diff.explainedItems': 'Explained items',
  'ava.diff.unexplained': 'Unexplained difference',
  'ava.items.reasonRequired': 'Enter what the item is due to. Without a justification it does not count as explained.',
  'ava.items.title': 'Reconciliation items',
  'ava.items.colReason': 'What the item is due to',
  'ava.items.colClassification': 'Classification',
  'ava.items.colAction': 'Action',
  'ava.items.missingReason': 'Missing justification',
  'ava.items.followUpDue': 'Follow-up deadline',
  'ava.items.voucherBasis': 'Voucher basis',
  'ava.items.markUnresolved': 'Mark unresolved',
  'ava.items.markResolved': 'Mark resolved',
  'ava.items.reasonPlaceholder': 'What is the item due to?',
  'ava.account.backTo': 'Back to {area}',
  'ava.account.basisChanged': 'The booked balance has changed since the account was reconciled. The basis is no longer the same.',
  'ava.account.reconciledAgo': 'reconciled {when}',
  'ava.account.accountingData': 'Accounting data',
  'ava.account.area': 'Area',
  'ava.account.lastUpdated': 'Last updated',
  'ava.account.reconciledAgainst': 'Reconciled against',
  'ava.account.bookedBalanceNote': 'The booked balance is taken from the trial balance the app calculates. If the books change, the figure follows.',
  'ava.account.externalBasis': 'External basis',
  'ava.account.externalBalance': 'External balance',
  'ava.account.externalBalanceOptional': 'External balance (optional here)',
  'ava.account.externalBalancePlaceholder': 'E.g. 124 500,00',
  'ava.account.externalBalanceNumber': 'The external balance must be a number.',
  'ava.account.documentDate': 'Document date',
  'ava.account.source': 'Source',
  'ava.account.sourcePlaceholder': 'E.g. account statement from DNB, retrieved 03.09',
  'ava.account.reference': 'Reference',
  'ava.account.referencePlaceholder': 'E.g. statement number or voucher reference',
  'ava.account.docsLinkedOne': '{count} document is linked to the account.',
  'ava.account.docsLinkedMany': '{count} documents are linked to the account.',
  'ava.account.docsNone': 'No documents are linked to the account. Upload in the panel on the right, or write a note below.',
  'ava.account.documentNote': 'Additional note on the documentation',
  'ava.account.documentNotePlaceholder': 'E.g. "Account statement downloaded 03.09"',
  'ava.account.differenceCalc': 'Difference calculation',
  'ava.account.conclusion': 'Conclusion',
  'ava.account.conclusionPlaceholder': 'What does the reconciliation show, and what is the conclusion based on?',
  'ava.account.remainingRisk': 'Remaining risk',
  'ava.account.remainingRiskPlaceholder': 'E.g. none',
  'ava.account.followUp': 'Follow-up next period',
  'ava.account.followUpPlaceholder': 'E.g. follow up unidentified incoming payment',
  'ava.account.statusChecked': 'Checked',
  'ava.account.statusReconciled': 'Reconciled',
  'ava.area.counts': '{approved} of {total} reconciled · {deviations} deviations · {missing} missing documentation',
  'ava.area.noExternalNeeded': 'does not require external basis',
  'ava.area.sendToControl': 'Send the area for review',
  'ava.area.noAccounts': 'No accounts have been added to this area yet. Open an account under "Other balance sheet" and move it here.',
  'ava.area.colBooked': 'Booked',
  'ava.area.colExternal': 'External',
  'ava.area.colUnexplained': 'Unexplained',
  'ava.area.colDocumentation': 'Documentation',
  'ava.area.changedAfterReconciliation': 'Changed after reconciliation',
  'ava.area.attached': 'Attached',
  'ava.area.missing': 'Missing',
  'ava.ctx.guide.bank': 'Booked balance against the bank statement at period end. Items in the bank that are not booked, and booked items that are not in the bank, must be explained.',
  'ava.ctx.guide.kundefordringer': 'General ledger against the accounts receivable ledger. Open items must be specifiable per customer, and old claims assessed for loss.',
  'ava.ctx.guide.leverandorgjeld': 'General ledger against the accounts payable ledger. Received invoices that are not booked belong to the period they relate to.',
  'ava.ctx.guide.payroll': 'The payroll accounts against the payroll journal and the a-melding: wages payable, holiday pay and accrued employer contribution.',
  'ava.ctx.guide.mva': 'The VAT accounts against the VAT return for the period. Basis and tax must be consistent, and the settlement account must be zero after payment.',
  'ava.ctx.guide.skatt': 'Tax withholding, employer contribution and tax payable against the a-melding and the Tax Administration settlement. Tax withholding must stay on its own account until it is paid.',
  'ava.ctx.guide.assets': 'Capitalised assets against the fixed asset register: acquisitions, disposals and the depreciation for the period.',
  'ava.ctx.guide.lan': 'Loans against the loan statement: opening balance, drawdowns, repayments and accrued interest must add up to the closing balance.',
  'ava.ctx.guide.egenkapital': 'Equity against the general meeting resolutions: profit for the year, dividends and other appropriations.',
  'ava.ctx.guide.other': 'Other balance sheet accounts. Each account must have a specification showing what the balance consists of.',
  'ava.ctx.guide.periodekontroll': 'The checks that apply to the whole period: that all vouchers are booked, that accruals are made, and that the reports are consistent.',
  'ava.ctx.term': 'Period',
  'ava.ctx.deadline': 'Deadline {date}',
  'ava.ctx.outputVat': 'Output VAT',
  'ava.ctx.inputVat': 'Input VAT',
  'ava.ctx.refundable': 'Refundable',
  'ava.ctx.payable': 'To pay',
  'ava.ctx.filed': 'The return has been filed',
  'ava.ctx.notFiled': 'The return has not been filed',
  'ava.ctx.activeAssets': 'Active assets',
  'ava.ctx.inAssetRegister': 'In the fixed asset register',
  'ava.ctx.soldThisYear': 'Sold this year',
  'ava.ctx.writtenOffThisYear': 'Written off this year',
  'ava.ctx.statementsLoaded': 'Account statements loaded',
  'ava.ctx.inBankView': 'In the bank view',
  'ava.ctx.unmatchedLines': 'Bank lines without a match',
  'ava.ctx.totalNotOnlyPeriod': 'Total, not only this period',
  'ava.ctx.unpaidInvoices': 'Unpaid invoices',
  'ava.ctx.statusToday': 'Status as of today, not at period end',
  'ava.ctx.outstandingAmount': 'Outstanding amount',
  'ava.ctx.title': 'Basis from the accounts',
  'ava.ctx.footnote': 'The figures are the accounts\' own, taken from the views that own them. They help you find the basis again, but they are not an external basis in themselves, so they are not filled in as the external balance.',
  'ava.ledger.age.d0to30': '0–30 days',
  'ava.ledger.age.d31to60': '31–60 days',
  'ava.ledger.age.d61to90': '61–90 days',
  'ava.ledger.age.over90': 'Over 90 days',
  'ava.ledger.age.noDate': 'No date',
  'ava.ledger.title': 'Postings in the period',
  'ava.ledger.allAccounts': 'All accounts in the area',
  'ava.ledger.onlyOld': 'Only older than 60 days',
  'ava.ledger.colText': 'Text',
  'ava.ledger.colAge': 'Age',
  'ava.ledger.noMatch': 'No postings match the filter.',
  'ava.ledger.noLines': 'No postings on the area\'s accounts in this period.',
  'ava.check.critical': 'Critical',
  'ava.check.reasonRequired': 'Justification required',
  'ava.check.reason': 'Justification',
  'ava.check.reasonPlaceholder': 'What is the deviation, and what is being done about it?',
  'ava.check.defaultGroup': 'Checkpoints',
  'ava.check.title': 'Professional checklist',
  'ava.check.titleReadOnly': 'Professional checklist (the preparer\'s, read-only)',
  'ava.check.noItems': 'No checkpoints are defined for this area.',
  'ava.check.progress': '{done} of {total} items assessed. The programme is the firm\'s own — it says what should be looked at, not what is allowed.',
  'ava.check.assessedAgo': 'Assessed {when}',
  'ava.saldo.descriptionRequired': 'Enter what the item is.',
  'ava.saldo.title': 'Balance specification',
  'ava.saldo.intro': 'Which items the balance consists of. The total must agree with the general ledger.',
  'ava.saldo.colCounterparty': 'Counterparty',
  'ava.saldo.colFrom': 'From',
  'ava.saldo.colTo': 'To',
  'ava.saldo.colDocument': 'Document',
  'ava.saldo.descriptionPlaceholder': 'What is the item?',
  'ava.saldo.docRefPlaceholder': 'Voucher/ref.',
  'ava.saldo.sum': 'Total of specification',
  'ava.saldo.deviates': 'Differs by {amount} from the general ledger',
  'ava.saldo.matchesLedger': 'Agrees with the general ledger',
  'ava.rollforward.title': 'Rolling reconciliation',
  'ava.rollforward.warning': 'The closing balance does not agree with the opening balance and the movement for the period. It is the trial balance that needs to be examined, not the reconciliation.',
  'ava.blocker.title': 'Cannot be marked as reconciled yet',
  'ava.blocker.note': 'The rules are enforced in the backend. Fix the items above and the status will open up by itself.',
  'ava.adjust.description': 'Reconciliation correction {account} {period}',
  'ava.adjust.copyDescription': 'Description: {value}',
  'ava.adjust.copyAmount': 'Amount: {value}',
  'ava.adjust.copyAccount': 'Account: {value}',
  'ava.adjust.copyDirection': 'Direction: {value}',
  'ava.adjust.accountDown': 'The account should go down',
  'ava.adjust.accountUp': 'The account should go up',
  'ava.adjust.copied': 'The basis has been copied. Paste it into a manual posting.',
  'ava.adjust.copyFailed': 'Could not copy. Copy the figures above by hand.',
  'ava.adjust.copyUnavailable': 'Copying is not available here. Copy the figures above by hand.',
  'ava.adjust.title': 'Create adjustment voucher',
  'ava.adjust.copyBasis': 'Copy the basis',
  'ava.adjust.period': 'Period',
  'ava.adjust.direction': 'Direction',
  'ava.adjust.note': 'The voucher itself is booked as a manual posting in the accounts, not here. That way it gets the same validation, the same voucher number and the same audit trail as everything else that is booked.',
  'ava.docs.kind.statement': 'Account statement',
  'ava.docs.kind.balanceConfirmation': 'Balance confirmation',
  'ava.docs.kind.subledgerList': 'Subledger list',
  'ava.docs.kind.aMelding': 'A-melding',
  'ava.docs.kind.vatReturn': 'VAT return',
  'ava.docs.kind.agreement': 'Agreement',
  'ava.docs.kind.other': 'Other',
  'ava.docs.req.waiting': 'Awaiting reply',
  'ava.docs.req.answered': 'Answered',
  'ava.docs.req.closed': 'Closed',
  'ava.docs.loading': 'Fetching the document …',
  'ava.docs.unsupportedType': 'This file type cannot be displayed here.',
  'ava.docs.openInNewTab': 'Open in new tab',
  'ava.docs.size': 'Size',
  'ava.docs.fromClient': 'From the client',
  'ava.docs.uploadedByFirm': 'Uploaded by the firm',
  'ava.docs.uploadedBy': 'Uploaded by',
  'ava.docs.time': 'Time',
  'ava.docs.linkedTo': 'Linked to',
  'ava.docs.wholePeriod': 'The whole period',
  'ava.docs.colUploaded': 'Uploaded',
  'ava.docs.sourceClient': 'The client',
  'ava.docs.sourceFirm': 'The firm',
  'ava.docs.viewDocument': 'View document',
  'ava.docs.noneForAccount': 'No documents linked to this account.',
  'ava.docs.noneForPeriod': 'No documents uploaded in this period.',
  'ava.docs.preview': 'Preview',
  'ava.docs.open': 'Open',
  'ava.docs.documentType': 'Document type',
  'ava.docs.upload': 'Upload document',
  'ava.docs.noRequests': 'No requests sent for this period.',
  'ava.docs.dueDate': 'Reply deadline {date}',
  'ava.docs.noDueDate': 'No reply deadline',
  'ava.docs.sentBy': 'sent by {email}',
  'ava.docs.documentsReceived': '{count} document received',
  'ava.docs.markAnswered': 'Mark as answered',
  'ava.docs.sendRequest': 'Send request',
  'ava.docs.concerns': 'Concerns {account}',
  'ava.docs.subject': 'Subject',
  'ava.docs.subjectPlaceholder': 'E.g. Account statement for August',
  'ava.docs.whatDoYouNeed': 'What do you need',
  'ava.docs.bodyPlaceholder': 'Describe what is missing and why it is needed',
  'ava.docs.requestedDocumentation': 'Requested documentation',
  'ava.docs.requestedDocumentationPlaceholder': 'E.g. account statement from the bank',
  'ava.docs.dueLabel': 'Reply deadline',
  'ava.docs.requestNote': 'The request is placed in the dialogue you have with the client, and stays here until it is answered.',
  'ava.drawer.ariaLabel': 'Reconciliation for {name}',
  'ava.drawer.org': 'Org. {org}',
  'ava.drawer.openFolder': 'Open the whole reconciliation folder',
  'ava.drawer.responsible': 'Responsible',
  'ava.drawer.deadline': 'Deadline',
  'ava.drawer.progress': 'Progress',
  'ava.drawer.locked': 'The period is locked. Reopening requires a justification.',
  'ava.drawer.statusNote': 'The status per area is derived from the accounts under it. It is not set here — an area cannot be shown as reconciled while an account has an unexplained difference.',
  'ava.drawer.filterTitle': 'Show clients with open items in',
  'ava.drawer.clearAll': 'Remove all',
});
